import { Button, Space } from 'antd';

// AiActionButtonGroup — renders one position bucket ("top-left", "bottom-right",
// etc.) of a field's AI action buttons, admin-configured entirely via each
// action's `position`. Horizontal alignment follows the position's own
// left/center/right suffix; the caller places top vs. bottom buckets around
// the field itself.
export default function AiActionButtonGroup({ position, actions, aiActions, groupName, field }) {
  if (!actions || actions.length === 0) return null;

  const justifyContent = position.endsWith('center')
    ? 'center'
    : position.endsWith('right')
      ? 'flex-end'
      : 'flex-start';

  return (
    <Space size={8} className="v1-ai-action-buttons" style={{ width: '100%', justifyContent }}>
      {actions.map((action) => (
        <Button
          key={action.key}
          size="small"
          loading={aiActions.loadingKey === action.key}
          disabled={aiActions.busy || !aiActions.isActionEnabled(action)}
          onClick={() => aiActions.runAction(groupName, field, action)}
        >
          {action.label}
        </Button>
      ))}
    </Space>
  );
}
